export default __webpack_public_path__ + "static/media/line-item-black.07bd8894.svg";